import { FormInstance } from "antd/es/form";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

export interface IExcelModal_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IExcelModal_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  GetExcelBase64: string;
  GetExcelBase64_dummy: string;
  DownloadFile: any;
  DownloadFile_dummy: any;
  ImportMappedExcel: any;
  ImportMappedExcel_dummy: any;
  DeleteExcelAnaVeri: number;
  DeleteExcelAnaVeri_dummy: number;
  GetExcelVerileri: any[];
  GetExcelVerileri_dummy: any[];
  InsertExcelTablo: number;
  InsertExcelTablo_dummy: number;
  ForEach6: GetExcelVerileri;
  ForEach6_dummy: GetExcelVerileri;
  SilExcelVerileri: number;
  SilExcelVerileri_dummy: number;
  GoBack: any;
  GoBack_dummy: any;
  GetExcelSablon: any[];
  GetExcelSablon_dummy: any[];
}

export class ExcelModal_ScreenBase extends React.PureComponent<
  IExcelModal_ScreenProps,
  any
> {
  ml = [
    {
      Id: "e6553d05-98ae-4ab8-be91-cc851f894a0b",
      Name: "en_US",
      ShortName: "English",
      LanguagePhrases: [
        {
          Id: 100196,
          PropertyName: "value",
          Value:
            'In order for the data to be assigned to you, you can select the "Current Username" option in the "UserName" field as shown in the image above and continue your process.',
          TagName: "Label2_value",
        },
        {
          Id: 944131,
          PropertyName: "label",
          Value: "Download Chart",
          TagName: "Button2_label",
        },
        {
          Id: 159602,
          PropertyName: "label",
          Value: "Next",
          TagName: "Button1_label",
        },
      ],
    },
    {
      Id: "ef30cc19-66ab-ea0f-c492-2e57cb69ffd2",
      Name: "es_ES",
      ShortName: "Spanish",
      LanguagePhrases: [
        {
          Id: 100196,
          PropertyName: "value",
          Value:
            "Para que los datos se le puedan asignar, marca la opción «Current Username» en el campo «UserName», tal y como se muestra en la imagen anterior, y continúa con el proceso.",
          TagName: "Label2_value",
        },
        {
          Id: 944131,
          PropertyName: "label",
          Value: "Descargar plantilla",
          TagName: "Button2_label",
        },
        {
          Id: 159602,
          PropertyName: "label",
          Value: "Siguiente",
          TagName: "Button1_label",
        },
      ],
    },
    {
      Id: "cd8e66ca-d8dd-1a05-bdac-f63ba9f6777b",
      Name: "fr_FR",
      ShortName: "French",
      LanguagePhrases: [
        {
          Id: 100196,
          PropertyName: "value",
          Value:
            "Pour que les données puissent vous être attribuées, cochez l’option « Nom d’utilisateur actuel » dans le champ « Nom d’utilisateur » comme indiqué sur l’image ci-dessus, puis poursuivez votre opération.",
          TagName: "Label2_value",
        },
        {
          Id: 944131,
          PropertyName: "label",
          Value: "Télécharger le modèle",
          TagName: "Button2_label",
        },
        {
          Id: 159602,
          PropertyName: "label",
          Value: "Suivant",
          TagName: "Button1_label",
        },
      ],
    },
    {
      Id: "f1e96f18-81d9-6312-1ebe-139d61cd7180",
      Name: "tr_TR",
      ShortName: "Turkish",
      LanguagePhrases: [],
    },
    {
      Id: "44b52b2e-b6f9-4716-8878-4ba81475a3ec",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 944131, PropertyName: "label", Value: "Şablon İndir" },
        { Id: 159602, PropertyName: "label", Value: "İleri" },
        {
          Id: 100196,
          PropertyName: "value",
          Value:
            'Verilerin size atanabilmesi için, yukarıdaki görselde gösterildiği gibi "UserName" alanında "Current Username" seçeneğini işaretleyip, İşleminize devam edebilirsiniz.',
        },
      ],
    },
  ];
  defaultML = "tr_TR";

  screenHash = "";

  ForEach6: any[];

  constructor(props) {
    super(props);

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      GetExcelBase64: "",
      DownloadFile: "",
      ImportMappedExcel: "",
      DeleteExcelAnaVeri: 0,
      GetExcelVerileri: [],
      ForEach: false,
      SilExcelVerileri: 0,
      GoBack: "",
      GetExcelSablon: [],
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("excelmodal", "");
      return;
    }

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (true) {
      await this.ExcelModalPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight("excelmodal", "");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("excelmodal", "");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.ExcelModalPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({});
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  ExcelModalPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {};

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "ExcelModal/ExcelModalPageInit",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetExcelSablon = result?.data.getExcelSablon;
    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };

  ExcelModalComponent_944131_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      value_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, this.state.GetExcelSablon),
        "any"
      ),
      header_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("", "string"),
        "string"
      ),
      footer_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("", "string"),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "ExcelModal/ExcelModalComponent_944131_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetExcelBase64 = result?.data.getExcelBase64;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.ExcelModalComponent_944131_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  ExcelModalComponent_944131_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.DownloadFile = await ReactSystemFunctions.downloadFile(
      ReactSystemFunctions.toString(this, this.state.GetExcelBase64),
      ReactSystemFunctions.convertToTypeByName("b2bSablon", "string")
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  ExcelModalComponent_159602_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.ImportMappedExcel =
      await ReactSystemFunctions.openImportMappedExcelModal(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "2921bc9c-ce2e-4381-9fcd-08912a0cd4a0",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("ExcelImport", "string"),
        ReactSystemFunctions.convertToTypeByName("Id", "string"),
        ReactSystemFunctions.convertToTypeByName(
          '[{"isEnabled":true,"source":"Id","alias":"Id","primaryKey":null,"isRequired":true},{"isEnabled":true,"source":"Kod","alias":"kod","primaryKey":null,"isRequired":false},{"isEnabled":true,"source":"Miktar","alias":"miktar","primaryKey":null,"isRequired":false},{"isEnabled":true,"source":"Not1","alias":"not1","primaryKey":null,"isRequired":false},{"isEnabled":true,"source":"Not2","alias":"not2","primaryKey":null,"isRequired":false},{"isEnabled":true,"source":"UserName","alias":"UserName","primaryKey":null,"isRequired":false}]',
          "string"
        )
      );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.ExcelModalComponent_159602_onClick1_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  ExcelModalComponent_159602_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      UserName_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUsername(),
        "string"
      ),
      UserName_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUsername(),
        "string"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "ExcelModal/ExcelModalComponent_159602_onClick1_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.DeleteExcelAnaVeri = result?.data.deleteExcelAnaVeri;
    stateVars.GetExcelVerileri = result?.data.getExcelVerileri;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.ExcelModalComponent_159602_onClick2_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  ExcelModalComponent_159602_onClick_foreach2 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      KuikaID_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, this.ForEach6?.id),
        "Guid"
      ),
      Kod_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, this.ForEach6?.kod),
        "string"
      ),
      Miktar_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, this.ForEach6?.miktar),
        "number"
      ),
      Not1_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, this.ForEach6?.not1),
        "string"
      ),
      Not2_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, this.ForEach6?.not2),
        "string"
      ),
      UserName_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, this.ForEach6?.userName),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "ExcelModal/ExcelModalComponent_159602_onClick_foreach2",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.InsertExcelTablo = result?.data.insertExcelTablo;
    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };

  ExcelModalComponent_159602_onClick2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    if (ReactSystemFunctions.value(this, this.state.GetExcelVerileri)?.length) {
      for (let item of ReactSystemFunctions.value(
        this,
        this.state.GetExcelVerileri
      )) {
        this.ForEach6 = item;
        await this.ExcelModalComponent_159602_onClick_foreach2();
      }
    }

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.ExcelModalComponent_159602_onClick3_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  ExcelModalComponent_159602_onClick3_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      UserName_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUsername(),
        "string"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "ExcelModal/ExcelModalComponent_159602_onClick3_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.SilExcelVerileri = result?.data.silExcelVerileri;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.ExcelModalComponent_159602_onClick4_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  ExcelModalComponent_159602_onClick4_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.GoBack = await ReactSystemFunctions.goBack(this, false);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.ExcelModalPageInit();
    }
  }
}
